import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { TextControl } from '@wordpress/components';

export default function Edit(props) {

    const { attributes, setAttributes } = props

    const setName = (name) => setAttributes({name})

    return (
        <div {...useBlockProps({ className: 'level131-tab'} )}>
            <div className="tab-name">
                <TextControl
                    value={attributes.name}
                    onChange={setName}
                    placeholder="Nome da aba"
                    style={{
                        border: 'none',
                        padding: '1rem',
                        padding: '1rem',
                        borderBottom: '1px solid #ddd'
                    }}
                />
            </div>
            <div className="tab-content">
                <InnerBlocks template={[ 
                    ['core/paragraph']
                ]} />
            </div>
        </div>
    );
}
